require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/~/core-js/library/fn/object/assign.js
// module id = 469
// module chunks = 0